module.exports = __webpack_public_path__ + "img/wban-logo-bsc.1c53fe25.svg";